export class DebuggerList {

  // TODO use static map to avoid calc

  constructor(private debuggers: Debugger[]) {
  }

  canAccess(currentUserId: number | null, liveMagazineId: number, liveUserId: number): boolean {
    if (this.debuggers.length !== 0) {
      let isDebugUser: boolean = false
      let isDebugMagazine: boolean = false
      let isDebugLive: boolean = false
      const debugMagazines = this.debuggers[0].magazines
      const debugUsers = this.debuggers[0].users

      if (debugMagazines.length !== 0) {
        // liveのmagazineIdがDebuggersに含まれているかどうか判定
        isDebugMagazine = debugMagazines.includes(Number(liveMagazineId))
      }

      if (debugUsers.length !== 0) {
        // ログイン中のuserIdがDebuggersに含まれているかどうか判定
        isDebugUser = debugUsers.includes(Number(currentUserId))
        // 配信者のuserIdがDebuggersに含まれているかどうか判定
        isDebugLive = debugUsers.includes(Number(liveUserId))
      }

      // ログイン中のユーザーがデバッグユーザーなら全て表示
      if (isDebugUser) {
        return true
      }

      if (isDebugMagazine || isDebugLive) {
        // デバッグライブなら非表示にする
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

}


export type Debugger = {
  magazines: number[],
  users: number[],
}
